// extracted by mini-css-extract-plugin
module.exports = {"backLink":"AutomationHistoryContent_backLink__1paA8","content":"AutomationHistoryContent_content__GGard","footer":"AutomationHistoryContent_footer__e8_9a"};